import { Component } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

class Sidebar extends Component {
    render() {
        const { active, menus, root } = this.props;
  
        return (
            <>
                {
                    menus.map(menu => {

                        const arrowMenu = root == true ? (menu.children.length > 0 ? 'has-arrow waves-effect' : 'waves-effect') : (menu.children.length > 0 ? 'has-arrow' : '')
                        const linkMenu = "#"
        
                        return (
                            <li key={menu.document_id}>
                                <Link to={linkMenu} className={arrowMenu}>
                                    {menu.document_name}
                                </Link>
                                { menu.children.length > 0 ? <ul className="sub-menu"><Sidebar menus={menu.children}/> </ul> : <></> }
                            </li>
                        )
                    })
                }
            </>
        )
    }
  }
  
  export default Sidebar;